import React from "react";
import {vectorToString} from "./CameraAdmin";
import {IViewCamera, IViewpoint, IViewpointGroup} from "../../data/IViewpoint";


const ViewpointAdminInfo: React.FC<{
    viewpointGroup: IViewpointGroup,
    enabledViewpoints: IViewCamera[],
    onViewViewpoint: (viewpoint: IViewpoint) => void
}> = (props) => {
    const { viewpointGroup, onViewViewpoint, enabledViewpoints } = props;


    function findViewpoint(vpName:string) {
        return enabledViewpoints.find(evp => evp.camera === vpName )
    }
    return <table>
        <tr>
            <th>ID</th>
            <th>Enabled</th>
            <th>Name</th>
            <th>Location</th>
            <th>LookAtDirection</th>

        </tr>
        {viewpointGroup.Viewpoints.map(vp => <tr style={{backgroundColor: findViewpoint(vp.Name) ? "lightgreen" : "inherit"}}>

            <td>
                <a href={'#'} onClick={(ev) => {
                    ev.preventDefault();
                    onViewViewpoint(vp);
                return false;
                } }>{ vp.Name }</a>
            </td>
            <td>
                { findViewpoint(vp.Name)?.name}
            </td>
            <td>
                { vp.DisplayName }
            </td>
            <td>
                { vectorToString({x: vp.Location.X, y: vp.Location.Y, z: vp.Location.Z})}
            </td>

            <td>
                { vectorToString({x: vp.LookAtDirection.X, y: vp.LookAtDirection.Y, z: vp.Location.Z})}
            </td>

        </tr>)}
    </table>
}
export default ViewpointAdminInfo;